import { all, call, put, select, takeLatest } from 'redux-saga/effects'

import {
  LOAD_COLLECTION_DETAILS_PAGE,
  LOAD_RESOURCE_DETAILS_PAGE,
  SUBMIT_FAVORITE_FROM_COLLECTION_PAGE,
  SUBMIT_FAVORITE_FROM_EXPLORE_PAGE,
  SUBMIT_FAVORITE_FROM_FAVORITES_PAGE,
  SUBMIT_FAVORITE_FROM_RESOURCE_PAGE,
} from './actions'

import {
  getAllResourcesService,
  getCollectionDetailsService,
  getCollectionResourcesService,
  getFavoritesService,
  getResourceDetailsService,
  postFavoriteService,
  setResourceDetailsFavorite,
} from './index'

interface ActionPayload {
  payload: any
}

type RequestSaga = (arg: unknown) => Generator

function* submitFavoriteFromFavoritesPageSaga({ payload }: ActionPayload): any {
  const favoriteResult: any = yield call(postFavoriteService.requestSaga as RequestSaga, {
    payload,
  })
  if (favoriteResult.error) return
  yield call(getFavoritesService.requestSaga as RequestSaga, {})
}

function* submitFavoriteFromCollectionPageSaga({ payload }: ActionPayload): any {
  const queryId = payload.data.collection_slug

  const favoriteResult: any = yield call(postFavoriteService.requestSaga as RequestSaga, {
    payload,
  })
  if (favoriteResult.error) return
  yield call(getCollectionResourcesService.requestSaga as RequestSaga, {
    payload: { urlParams: queryId },
  })
}

function* submitFavoriteFromResourcePageSaga({ payload }: ActionPayload): any {
  const favoriteResult: any = yield call(postFavoriteService.requestSaga as RequestSaga, {
    payload,
  })
  if (favoriteResult.error) return
  yield put(setResourceDetailsFavorite(payload.data.resource_id, Boolean(payload.data.favorite)))
}

function* submitFavoriteFromExplorePageSaga({ payload }: ActionPayload): any {
  const favoriteResult: any = yield call(postFavoriteService.requestSaga as RequestSaga, {
    payload,
  })
  if (favoriteResult.error) return
  yield call(getAllResourcesService.requestSaga as RequestSaga, {})
}

function* loadResourceDetailsPageSaga({ payload }: ActionPayload): any {
  yield call(getResourceDetailsService.requestSaga as RequestSaga, {
    payload: { urlParams: payload.slug, req: payload.req },
  })
  const resourceItem: any = yield select((state: any) => state.resource.details.item)
  if (resourceItem) {
    yield call(getCollectionDetailsService.requestSaga as RequestSaga, {
      payload: { urlParams: resourceItem.collection_slug, req: payload.req },
    })
    yield call(getCollectionResourcesService.requestSaga as RequestSaga, {
      payload: { urlParams: resourceItem.collection_slug, req: payload.req },
    })
  }
}

function* loadCollectionDetailsPageSaga({ payload }: ActionPayload): any {
  yield call(getCollectionDetailsService.requestSaga as RequestSaga, {
    payload: { urlParams: payload.slug, req: payload.req },
  })
  const collectionItem: any = yield select((state: any) => state.collection.details.item)
  if (collectionItem) {
    yield call(getCollectionResourcesService.requestSaga as RequestSaga, {
      payload: { urlParams: collectionItem.slug, req: payload.req },
    })
  }
}

export default function* saga(): any {
  yield all([
    // @ts-expect-error action pattern strings are valid runtime values
    takeLatest(SUBMIT_FAVORITE_FROM_FAVORITES_PAGE, submitFavoriteFromFavoritesPageSaga),
    // @ts-expect-error action pattern strings are valid runtime values
    takeLatest(SUBMIT_FAVORITE_FROM_COLLECTION_PAGE, submitFavoriteFromCollectionPageSaga),
    // @ts-expect-error action pattern strings are valid runtime values
    takeLatest(SUBMIT_FAVORITE_FROM_RESOURCE_PAGE, submitFavoriteFromResourcePageSaga),
    // @ts-expect-error action pattern strings are valid runtime values
    takeLatest(SUBMIT_FAVORITE_FROM_EXPLORE_PAGE, submitFavoriteFromExplorePageSaga),
    // @ts-expect-error action pattern strings are valid runtime values
    takeLatest(LOAD_RESOURCE_DETAILS_PAGE, loadResourceDetailsPageSaga),
    // @ts-expect-error action pattern strings are valid runtime values
    takeLatest(LOAD_COLLECTION_DETAILS_PAGE, loadCollectionDetailsPageSaga),
  ])
}
